import { IObstetricaLabResultsGroup } from "@/Common/Api/Labs/Dto/Responses/LabMessageGroupDTO";
import { BaseBritishColumbiaObstetricalFileSubSection, BaseBritishColumbiaObstetricalFileSubSectionProps } from "@/Patient/Components/MedicalNote/Obstetric/Form/BritishColumbia/Subcomponent/BaseBritishColumbiaObstetricalFileSubSection";
import { BritishColumbiaObstetricalFileLabWidget } from "./Section13/BritishColumbiaObstetricalFileLabWidget";
import { BritishColumbiaObstetricalFileTestsSubSection } from "./Section13/BritishColumbiaObstetricalFileTestsSubSection";
import { BritishColumbiaObstetricalInvestigationsAboRhFactor } from "./Section13/BritishColumbiaObstetricalInvestigationsAboRhFactor";
import { BritishColumbiaObstetricalPrenatalGeneticInvestigation } from "./Section13/BritishColumbiaObstetricalPrenatalGeneticInvestigation";

class BritishColumbiaObstetricalFileSection13State {
    public obstetricalFileLabObservations: IObstetricaLabResultsGroup[];

    public static getDefaultState(): BritishColumbiaObstetricalFileSection13State {
        const state: BritishColumbiaObstetricalFileSection13State = {
            obstetricalFileLabObservations: []
        };
        return state;
    }
}

class BritishColumbiaObstetricalFileSection13 extends BaseBritishColumbiaObstetricalFileSubSection<BaseBritishColumbiaObstetricalFileSubSectionProps, BritishColumbiaObstetricalFileSection13State> {
    constructor(props: BaseBritishColumbiaObstetricalFileSubSectionProps) {
        super(props);
        this.state = BritishColumbiaObstetricalFileSection13State.getDefaultState();
    }

    public componentDidMount(): void {
        this.initState();
    }

    public componentDidUpdate(prevProps: BaseBritishColumbiaObstetricalFileSubSectionProps): void {
        if (this.props.patient.IndividualResponse.Contact_id != prevProps.patient.IndividualResponse.Contact_id) {
            this.initState();
        }
    }

    protected initState(): void {
        this.props.fetchLabObservations?.().then(
            labs => this.mutateState(s => s.obstetricalFileLabObservations = labs)
        );
    }

    public render(): JSX.Element {
        return (
            <div>
                <div className="border border-bottom">
                    <div className="section">
                        {this.renderTitle(13, "InvestigationsLabel")}
                        <BritishColumbiaObstetricalInvestigationsAboRhFactor {...this.props} />
                    </div>

                    {this.state.obstetricalFileLabObservations?.any() && (
                        <BritishColumbiaObstetricalFileLabWidget
                            obstetricalFileLabObservations={this.state.obstetricalFileLabObservations}
                            finalEDB={this.props.form.Section3.EstimatedDateOfBirthByUltrasound ?? this.props.form.Section3.EstimatedDateOfBirthByLastMenstrualPeriod}
                        />
                    )}

                    <BritishColumbiaObstetricalFileTestsSubSection {...this.props} />
                    <BritishColumbiaObstetricalPrenatalGeneticInvestigation {...this.props} />
                </div>
            </div>
        );
    }
}

export { BritishColumbiaObstetricalFileSection13 };
